import { render, staticRenderFns } from "./FormsDetails.vue?vue&type=template&id=24f035c3&"
import script from "./FormsDetails.vue?vue&type=script&lang=js&"
export * from "./FormsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports